<template>
  <div>
    <el-table :data="assetDetailPoolData">
      <el-table-column prop="consumeTime" label="消费时间" align="center" :show-overflow-tooltip="true" >
        <template slot-scope="{row}">
          <span >{{row.startTime}} ~ {{row.endTime}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="consumeType" label="消费类型" align="center">
        <template slot-scope="{row}">
          <span v-if="row.consumeType ==='1'">单卡功能管理费</span>
          <span v-else-if="row.consumeType ==='2'">单卡停机保号费</span>
          <span v-else-if="row.consumeType ==='3'">超流费</span>
          <span v-else-if="row.consumeType ==='4'">流量费</span>
          <span v-else-if="row.consumeType ==='5'">卡月费</span>
          <span v-else-if="row.consumeType ==='6'">续费</span>
          <span v-else-if="row.consumeType ==='7'">加油包</span>
          <span v-else-if="row.consumeType ==='8'">单卡低消费用</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="cardNumber" label="扣费卡数量(张)" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <div style="color: #4466AD;cursor: pointer;text-decoration: underline;" @click="selectCards(scope.row)">{{ scope.row.cardNumber }}</div>
        </template>
      </el-table-column>
      <el-table-column label="单价(元)" align="center">
        <template slot-scope="{row}">
          <span v-if="row.consumeType ==='1'">{{row.product.cardFunctionFee}} 元/月/单卡</span>
          <span v-if="row.consumeType ==='2'">{{row.product.cardProductFee}} 元/月/单卡</span>
          <span v-if="row.consumeType ==='3'">{{row.product.singleOverFlowFee}} 元/GB/月</span>
          <span v-if="row.consumeType ==='4'">{{row.product.singlePrice}} 元/GB</span>
          <span v-if="row.consumeType ==='5'">{{row.product.singlePrice}} 元/月</span>
          <span v-if="row.consumeType ==='8'">{{row.product.singleLowFlowFee}} 元/月</span>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="消费金额(元)" align="center"></el-table-column>
      <el-table-column prop="payMode" label="支付方式" align="center">
        <template slot-scope="{row}">
          <span v-if="row.payMode ==='1' ">微信支付</span>
          <span v-else-if="row.payMode ==='2' ">支付宝支付</span>
          <span v-else-if="row.payMode ==='3' ">余额支付</span>
          <span v-else-if="row.payMode ==='4' ">系统支付</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="operator" label="操作人" align="center">
        <template slot-scope="{row}">
          <span v-if="row.operator ==='1'">用户</span>
          <span v-else-if="row.operator ==='2'">系统</span>
          <span v-else>代理商</span>
        </template>
      </el-table-column>
    </el-table>
    <!--卡列表弹窗-->
    <el-dialog title="卡列表" width="800px" :visible.sync="showDialog" @close="dialogClose" v-dialogDrag :modal-append-to-body="false" :close-on-click-modal="false">
        <el-table :data="cardList" border :header-cell-style ="{background: '#EEF1F6',color: '#606266'}">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="iccid" label="ICCID" align="center"></el-table-column>
          <el-table-column v-if="consumeType == '1'" label="单卡功能管理费" align="center" >
            <template slot-scope="{row}">
              {{row.product.cardFunctionFee}}元/月
            </template>
          </el-table-column>
          <el-table-column v-if="consumeType == '2'" label="单卡停机保号费" align="center" >
            <template slot-scope="{row}">
              {{row.product.cardProductFee}}元/月
            </template>
          </el-table-column>
          <template v-if="consumeType == '3'">
            <el-table-column prop="strMonthFlow" v-if="adminShow"  label="月流量" align="center"></el-table-column>
            <el-table-column prop="overMonthFlow" v-if="adminShow"   label="超流流量" align="center"></el-table-column>
            <el-table-column label="超流费用" align="center">
              <template slot-scope="{row}">
                {{row.product.singleOverFlowFee}}元/GB/月
              </template>
            </el-table-column>
          </template>
          <template v-if="consumeType == '4'">
            <el-table-column prop="strMonthFlow"  label="月流量" align="center"></el-table-column>
            <el-table-column label="流量费用" align="center">
              <template slot-scope="{row}">
                {{row.product.singlePrice}}元/GB
              </template>
            </el-table-column>
          </template>
          <template v-if="consumeType == '5'">
            <el-table-column label="卡月费" align="center">
              <template slot-scope="{row}">
                {{row.product.singlePrice}}元/月
              </template>
            </el-table-column>
          </template>
          <template v-if="consumeType == '8'">
            <el-table-column prop="strMonthFlow" v-if="adminShow"   label="月流量" align="center"></el-table-column>
            <el-table-column label="低消费用" align="center">
              <template slot-scope="{row}">
                {{row.product.singleLowFlowFee}}元/月
              </template>
            </el-table-column>
          </template>
        </el-table>
        <pagination
          v-show="total>0"
          :total="total"
          :page.sync="page"
          :limit.sync="pageSize"
          @pagination="initPoolCardData"
        />
    </el-dialog>
  </div>
</template>
<script>
import { userAssetDetailPoolRecord , userAssetDetailPoolCards } from "@/api/api.js";
export default {
  props: {
    poolProductId: {
      type: Number
    }
  },
  data() {
    return{
      assetDetailPoolData:[],
      showDialog:false,
      cardList:[],
      total:0,
      page:1,
      pageSize:10,
      consumeType:1,
      userAssetDetailPoolId:''
    }
  },
  computed: {
    adminShow() {
      return this.$store.getters.user.userType =='1'
    }
  },
  methods:{
    dateFormatDate(time){
      let dt = new Date(time);
      return this.dataFormat(dt);
    },
    dateFormatDateStartTime(row){
      let dt = new Date(row.orderTime);
      return this.dataFormat(dt);
    },
    dataFormat(dt){
      let year = dt.getFullYear();
      let month = dt.getMonth() + 1;
      let date = dt.getDate();
      return `${year}-${month}-${date}`;
    },
    // 获取流量池用户
    initTableData(){
      userAssetDetailPoolRecord({poolProductId:this.poolProductId}).then(res=>{
        this.assetDetailPoolData = res.data.data
      })
    },
    selectCards(row){
      this.showDialog = true;
      this.userAssetDetailPoolId = row.id
      this.consumeType = row.consumeType
      this.initPoolCardData()
    },
    dialogClose(){
      this.showDialog = false
      this.userAssetDetailPoolId  = ''
    },
    initPoolCardData(){
      let params= {
        model:{
          userAssetDetailPoolId:this.userAssetDetailPoolId
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      userAssetDetailPoolCards(params).then(res=>{
        this.cardList = res.data.data.records;
        this.total = res.data.data.total;
      })
    }
    
  },
  created() {
    this.initTableData()
  }
};
</script>


